import React from 'react'

export default props => (
	<div id={props.id} class={`${props.responsive ? 'table-responsive' : ''} ${props.border ? 'table-bordered' : ''}`} style={{ display: 'flex', overflowX: 'auto' }}>
	    <table className='table table-hover table-bordered'>
			{props.children}
		</table>
	</div>
)
